<app-date-input
  #dateInputComponent
  [value]="value?.date"
  (changed)="handleDateChange()"
  [postponeChangeUntilBlur]="postponeChangeUntilBlur"
></app-date-input>

<app-time-input
  #timeInputComponent
  [value]="value?.time"
  (changed)="handleTimeChange()"
  [postponeChangeUntilBlur]="postponeChangeUntilBlur"
></app-time-input>
